<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="cancelEntry">Cancel</ion-button>
        </ion-buttons>
        <ion-title>New Entry</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="saveEntry">Save</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-card color="light" v-for="(field, index) in form.fields" v-bind:key="index">
        <ion-item v-if="values[index]">
          <ion-icon color="tertiary" :ios="'ios-' + field.icon" :md="'md-' + field.icon" slot="start"></ion-icon>
          <ion-label color="primary" :position="field.position()">{{ field.title }}</ion-label>
          <field-text :field="field" :value="values[index]" v-if="field.type == 'text'"></field-text>
          <field-number :field="field" :value="values[index]" v-if="field.type == 'number'"></field-number>
          <field-email :field="field" :value="values[index]" v-if="field.type == 'email'"></field-email>
          <field-phone :field="field" :value="values[index]" v-if="field.type == 'phone'"></field-phone>
          <field-url :field="field" :value="values[index]" v-if="field.type == 'url'"></field-url>
          <field-boolean :field="field" :value="values[index]" v-if="field.type == 'boolean'"></field-boolean>
          <field-date :field="field" :value="values[index]" v-if="field.type == 'date'"></field-date>
          <field-time :field="field" :value="values[index]" v-if="field.type == 'time'"></field-time>
          <field-datetime :field="field" :value="values[index]" v-if="field.type == 'datetime'"></field-datetime>
          <field-select :field="field" :value="values[index]" v-if="field.type == 'select'"></field-select>
          <field-multiple :field="field" :value="values[index]" v-if="field.type == 'multiple'"></field-multiple>
          <field-readonly :field="field" :value="values[index]" v-if="field.type == 'image'"></field-readonly>
          <field-readonly :field="field" :value="values[index]" v-if="field.type == 'location'"></field-readonly>
          <field-readonly :field="field" :value="values[index]" v-if="field.type == 'signature'"></field-readonly>
          <field-readonly :field="field" :value="values[index]" v-if="field.type == 'qrcode'"></field-readonly>
          <field-readonly :field="field" :value="values[index]" v-if="field.type == 'barcode'"></field-readonly>
          <ion-note slot="end" color="danger" v-if="field.required">Required</ion-note>
        </ion-item>
        <field-image :field="field" :value="values[index]" v-if="field.type == 'image'"></field-image>
        <field-location :field="field" :value="values[index]" v-if="field.type == 'location'"></field-location>
        <field-signature :field="field" :value="values[index]" v-if="field.type == 'signature'"></field-signature>
        <field-qrcode :field="field" :value="values[index]" v-if="field.type == 'qrcode'"></field-qrcode>
        <field-barcode :field="field" :value="values[index]" v-if="field.type == 'barcode'"></field-barcode>
      </ion-card>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import UUID from "../models/Uuid";
import User from "../models/User";
import Form from "../models/Form";
import Field from "../models/Field";
import Fields from "../models/Fields";
import Entry from "../models/Entry";
import Value from "../models/Value";
import Values from "../models/Values";
import FieldText from "../components/FieldText.vue";
import FieldNumber from "../components/FieldNumber.vue";
import FieldEmail from "../components/FieldEmail.vue";
import FieldPhone from "../components/FieldPhone.vue";
import FieldUrl from "../components/FieldUrl.vue";
import FieldBoolean from "../components/FieldBoolean.vue";
import FieldDate from "../components/FieldDate.vue";
import FieldTime from "../components/FieldTime.vue";
import FieldDatetime from "../components/FieldDatetime.vue";
import FieldSelect from "../components/FieldSelect.vue";
import FieldMultiple from "../components/FieldMultiple.vue";
import FieldLocation from "../components/FieldLocation.vue";
import FieldImage from "../components/FieldImage.vue";
import FieldSignature from "../components/FieldSignature.vue";
import FieldBarcode from "../components/FieldBarcode.vue";
import FieldQrcode from "../components/FieldQrcode.vue";
import FieldReadonly from "../components/FieldReadonly.vue";
import router from "../router";
import store from "../store";
export default {
  store: store,
  router: router,
  name: "entry-edit",
  mixins: [Helpers, Plugins],
  components: {
    FieldText,
    FieldNumber,
    FieldEmail,
    FieldPhone,
    FieldUrl,
    FieldBoolean,
    FieldDate,
    FieldTime,
    FieldDatetime,
    FieldSelect,
    FieldMultiple,
    FieldLocation,
    FieldImage,
    FieldSignature,
    FieldQrcode,
    FieldBarcode,
    FieldReadonly
  },
  props: ["form"],
  data() {
    return {
      maxRetries: 1,
      entry: new Entry(),
      values: new Values()
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser();
    },
    offline() {
      let url = new URL(window.location.href);
      return url.searchParams.get("offline");
    }
  },
  created() {
    let date = new Date().toISOString();
    this.entry = new Entry({
      form: this.form.id,
      key: this.form.key,
      user: user.name,
      author: user.name,
      created: date
    });
    this.entry.setID(user.name, date);
    for (let field of this.form.fields) {
      let value = new Value({
        id: UUID.random(),
        type: field.type,
        icon: field.icon,
        title: field.title,
        ordinal: field.ordinal,
        required: field.required,
        value: undefined
      });
      this.values.push(value);
    }
  },
  mounted() {
    console.log("Offline", this.offline);
  },
  methods: {
    cancelEntry() {
      this.hideModal();
    },
    async saveEntry(retries = 0) {
      for (let value of this.values) {
        if (value.required && (value.value == null || value.value == undefined || value.value.length == 0)) {
          this.showToast(`${value.title} is required`);
          return;
        }
        if (value.type == "email" && value.isValidEmail() == false) {
          this.showToast(`${value.title} is not a valid email address`);
          return;
        }
        if (value.type == "phone" && value.isValidPhone() == false) {
          this.showToast(`${value.title} is not a valid phone number`);
          return;
        }
        if (value.type == "url" && value.isValidUrl() == false) {
          this.showToast(`${value.title} is not a valid URL`);
          return;
        }
      }
      if (this.offline == false && (await this.hasConnection())) {
        let loading = await this.showLoading("Saving...");
        try {
          this.entry.values = this.values;
          this.entry.pending = false;
          await this.entry.save();
          await this.entry.store();
          await this.form.touch();
          await this.form.store();
          this.hideModal({
            entry: this.entry
          });
        } catch (error) {
          if (this.expiredToken(error) && retries <= this.maxRetries) {
            await this.$store.dispatch("userRefresh");
            await this.saveEntry(retries + 1);
          } else {
            this.showError("Problem Saving Entry", error);
          }
        } finally {
          loading.dismiss();
        }
      } else {
        let loading = await this.showLoading("Storing...");
        try {
          this.entry.values = this.values;
          this.entry.pending = true;
          await this.entry.store();
          this.hideModal({
            entry: this.entry
          });
        } catch (error) {
          this.showError("Problem Storing Entry", error);
        } finally {
          loading.dismiss();
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
ion-note {
  font-size: 12px;
}
</style>
